import * as React from 'react';

const BouncedGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="bounced-graphic_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 96 96"
        xmlSpace="preserve"
        {...props}
    >
        <style>
            {
                '\n        .bounced-graphic_svg__st4,.bounced-graphic_svg__st7{clip-path:url(#bounced-graphic_svg__SVGID_10_);fill:none;stroke:#1e0a3c;stroke-width:2;stroke-miterlimit:10}.bounced-graphic_svg__st7{clip-path:url(#bounced-graphic_svg__SVGID_16_);stroke:#fff;stroke-width:1.5}\n    '
            }
        </style>
        <g id="bounced-graphic_svg__Icon">
            <defs>
                <path
                    id="bounced-graphic_svg__SVGID_1_"
                    d="M24.6 32.5h45.7v29.8H24.6z"
                />
            </defs>
            <clipPath id="bounced-graphic_svg__SVGID_2_">
                <use
                    xlinkHref="#bounced-graphic_svg__SVGID_1_"
                    overflow="visible"
                />
            </clipPath>
            <g clipPath="url(#bounced-graphic_svg__SVGID_2_)">
                <defs>
                    <path
                        id="bounced-graphic_svg__SVGID_3_"
                        d="M-463.5-496.5h960v1482h-960z"
                    />
                </defs>
                <clipPath id="bounced-graphic_svg__SVGID_4_">
                    <use
                        xlinkHref="#bounced-graphic_svg__SVGID_3_"
                        overflow="visible"
                    />
                </clipPath>
                <path
                    clipPath="url(#bounced-graphic_svg__SVGID_4_)"
                    fill="#f8faff"
                    d="M19.6 27.5h55.7v39.8H19.6z"
                />
            </g>
            <defs>
                <path
                    id="bounced-graphic_svg__SVGID_5_"
                    d="M70.3 32.5L47.5 53.3 24.6 32.5z"
                />
            </defs>
            <clipPath id="bounced-graphic_svg__SVGID_6_">
                <use
                    xlinkHref="#bounced-graphic_svg__SVGID_5_"
                    overflow="visible"
                />
            </clipPath>
            <g clipPath="url(#bounced-graphic_svg__SVGID_6_)">
                <defs>
                    <path
                        id="bounced-graphic_svg__SVGID_7_"
                        d="M-463.5-496.5h960v1482h-960z"
                    />
                </defs>
                <clipPath id="bounced-graphic_svg__SVGID_8_">
                    <use
                        xlinkHref="#bounced-graphic_svg__SVGID_7_"
                        overflow="visible"
                    />
                </clipPath>
                <path
                    clipPath="url(#bounced-graphic_svg__SVGID_8_)"
                    fill="#f8faff"
                    d="M19.6 27.5h55.7v30.9H19.6z"
                />
            </g>
            <g>
                <defs>
                    <path
                        id="bounced-graphic_svg__SVGID_9_"
                        d="M-463.5-496.5h960v1482h-960z"
                    />
                </defs>
                <clipPath id="bounced-graphic_svg__SVGID_10_">
                    <use
                        xlinkHref="#bounced-graphic_svg__SVGID_9_"
                        overflow="visible"
                    />
                </clipPath>
                <path
                    className="bounced-graphic_svg__st4"
                    d="M24.6 32.5h45.7v29.8H24.6z"
                />
                <path
                    className="bounced-graphic_svg__st4"
                    d="M70.7 62.5L57.8 49.6M24.6 62.5l12.9-12.9m32.8-17.1L47.5 53.3 24.6 32.5"
                />
            </g>
            <g>
                <defs>
                    <path
                        id="bounced-graphic_svg__SVGID_11_"
                        d="M80.3 32.5c0 5-4 9-8.9 9s-8.9-4-8.9-9 4-9 8.9-9 8.9 4 8.9 9"
                    />
                </defs>
                <clipPath id="bounced-graphic_svg__SVGID_12_">
                    <use
                        xlinkHref="#bounced-graphic_svg__SVGID_11_"
                        overflow="visible"
                    />
                </clipPath>
                <g clipPath="url(#bounced-graphic_svg__SVGID_12_)">
                    <defs>
                        <path
                            id="bounced-graphic_svg__SVGID_13_"
                            d="M-463.5-496.5h960v1482h-960z"
                        />
                    </defs>
                    <clipPath id="bounced-graphic_svg__SVGID_14_">
                        <use
                            xlinkHref="#bounced-graphic_svg__SVGID_13_"
                            overflow="visible"
                        />
                    </clipPath>
                    <path
                        clipPath="url(#bounced-graphic_svg__SVGID_14_)"
                        fill="#f05537"
                        d="M57.5 18.5h27.8v28H57.5z"
                    />
                </g>
            </g>
            <g>
                <defs>
                    <path
                        id="bounced-graphic_svg__SVGID_15_"
                        d="M-463.5-496.5h960v1482h-960z"
                    />
                </defs>
                <clipPath id="bounced-graphic_svg__SVGID_16_">
                    <use
                        xlinkHref="#bounced-graphic_svg__SVGID_15_"
                        overflow="visible"
                    />
                </clipPath>
                <path
                    className="bounced-graphic_svg__st7"
                    d="M75.1 28.7l-7.4 7.5M75.1 36.2l-7.4-7.5"
                />
            </g>
        </g>
    </svg>
);

BouncedGraphicSvg.displayName = 'BouncedGraphicSvg';
export default BouncedGraphicSvg;
